import getInstanceAxios from '../Request';

export default getInstanceAxios(process.env.REACT_APP_BOOKING_VIEW_MSA_DOMAIN);
